exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tooltip-type-list {\n  position: relative;\n  top: 0;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: block; }\n  .tooltip-type-list li {\n    position: relative;\n    display: block; }\n    .tooltip-type-list li .tooltip-data {\n      background: #ffc92c;\n      border-radius: 4px;\n      display: block;\n      width: 40px;\n      height: 40px;\n      padding: 0;\n      text-align: center;\n      margin-bottom: 7px;\n      box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.15); }\n      .tooltip-type-list li .tooltip-data:hover span {\n        opacity: 1;\n        visibility: visible;\n        display: block; }\n      .tooltip-type-list li .tooltip-data i {\n        color: #5d4e00;\n        font-size: 22px;\n        line-height: 40px; }\n  .tooltip-type-list span {\n    display: none;\n    position: absolute;\n    background: rgba(0, 0, 0, 0.7);\n    color: #fff;\n    font-weight: 600;\n    border-radius: 3px;\n    padding: 5px 8px;\n    line-height: 1.25;\n    left: 44px;\n    top: 7px;\n    z-index: 999;\n    white-space: nowrap;\n    font-size: 0.875em; }\n  .tooltip-type-list img {\n    width: 100%;\n    height: 100%; }\n\n.modal-body {\n  display: inline-block;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/tooltip/tooltip.component.scss
// module id = 504
// module chunks = 0